export default root => ({ query: { originTo, ...query } }) => {
  if (STAGE === STAGE_LOCAL && originTo) {
    return { path: originTo, query, replace: true }
  }
  return root
}
